import * as api from "./api";

export async function getSignallingTokens(body, options) {
	return await api.post("/backend/signalling/tokens", body, options);
}

export async function getIce(body, options) {
	return await api.post("/backend/p2p/ice", body, options);
}

export async function createChannel(body, options) {
	return await api.post("/create/p2p/channel", body, options);
}

export async function deleteChannel(body, options) {
	return await api.post("/backend/p2p/delete/channel", body, options);
}
